import React from "react";
import { Link } from "react-router-dom";

const Breadcrumbs = ({ links }) => {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li className="inline-flex items-center">
          <svg
            width={20}
            height={21}
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.7069 2.79303C10.5194 2.60556 10.2651 2.50024 9.99992 2.50024C9.73475 2.50024 9.48045 2.60556 9.29292 2.79303L2.29292 9.79303C2.11076 9.98163 2.00997 10.2342 2.01224 10.4964C2.01452 10.7586 2.11969 11.0094 2.3051 11.1948C2.49051 11.3803 2.74132 11.4854 3.00352 11.4877C3.26571 11.49 3.51832 11.3892 3.70692 11.207L3.99992 10.914V17.5C3.99992 17.7652 4.10528 18.0196 4.29281 18.2071C4.48035 18.3947 4.7347 18.5 4.99992 18.5H6.99992C7.26514 18.5 7.51949 18.3947 7.70703 18.2071C7.89456 18.0196 7.99992 17.7652 7.99992 17.5V15.5C7.99992 15.2348 8.10528 14.9805 8.29281 14.7929C8.48035 14.6054 8.7347 14.5 8.99992 14.5H10.9999C11.2651 14.5 11.5195 14.6054 11.707 14.7929C11.8946 14.9805 11.9999 15.2348 11.9999 15.5V17.5C11.9999 17.7652 12.1053 18.0196 12.2928 18.2071C12.4803 18.3947 12.7347 18.5 12.9999 18.5H14.9999C15.2651 18.5 15.5195 18.3947 15.707 18.2071C15.8946 18.0196 15.9999 17.7652 15.9999 17.5V10.914L16.2929 11.207C16.4815 11.3892 16.7341 11.49 16.9963 11.4877C17.2585 11.4854 17.5093 11.3803 17.6947 11.1948C17.8801 11.0094 17.9853 10.7586 17.9876 10.4964C17.9899 10.2342 17.8891 9.98163 17.7069 9.79303L10.7069 2.79303Z"
              fill="#6B7280"
            />
          </svg>
          <Link to="/">
            <a className="inline-flex items-center gap-3 text-sm font-medium text-[#374151] ml-2 hover:text-gray-500">
              Home
            </a>
          </Link>
        </li>
        {links?.map((link) => {
          return (
            <li>
              <div className="flex items-center">
                <svg
                  width={20}
                  height={21}
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 4.66675L13.3333 10.5001L7.5 16.3334"
                    stroke="#6B7280"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <Link to={link.link}>
                  <a
                    href="#"
                    className="ml-1 text-sm font-medium text-[#374151] capitalize hover:text-gray-500"
                  >
                    {link.name}
                  </a>
                </Link>
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
